let __USE_JAVASCRIPT_CONSOLE_LOG = document.getElementById('USE_JAVASCRIPT_CONSOLE_LOG').value;

/*----------------------------------------------------------------------
firstClickListener
----------------------------------------------------------------------*/
let firstEventPromise = Promise.resolve();

function firstClickListener(event) {
    /**
     * fetchData
     */
    async function fetchData() {
        const path = document.getElementById('SiteURL').value + 'neal_cms/neal_cms_includes/document_ready/document_ready_check_session_status.php';
        const formData = new FormData();
        const oApplication = document.getElementById('APPLICATION_NAME');

        formData.append('cApplicationName', oApplication.value);

        const response = await fetch(path, {
            method: 'POST',
            body: formData,
            cache: 'no-cache',
            credentials: 'same-origin'
        });

        const data = await response.text();
        return data;
    }

    firstEventPromise = new Promise((resolve) => {
        if (event.target.type === 'button' || event.target.classList[0] === 'btn' || event.target.type === 'button' || event.target.dataset.gridManagerEditColumn !== undefined || event.target.dataset.buttonType !== undefined) {
            /**
             * runJobs
             */
            const runJobs = async () => {
                const cResponse = await fetchData();
                if (cResponse === 'NO') {
                    event.stopImmediatePropagation();
                    event.stopPropagation();
                    event.preventDefault();
                    window.location = '?cms_page=user_login.php';
                } else {
                    resolve();
                }
            };
            runJobs();
        } else {
            resolve();
        }
    });
}

/*----------------------------------------------------------------------*/
/* DocumentReady                                                        */
/*----------------------------------------------------------------------*/
export let __cms_DocumentReady = new DocumentReady();

function DocumentReady() {
    if (__USE_JAVASCRIPT_CONSOLE_LOG === 'true') {
        console.log('called : (DocumentReady)');
    }
}

/*----------------------------------------------------------------------*/
/* PROTOTYPE : init                                                     */
/*----------------------------------------------------------------------*/
DocumentReady.prototype.init = function () {
    // const _ = this;

    // Create a variable to store the abort controller
    this.abortController = new AbortController();

    this.EventListeners();

    this.oApplication = document.getElementById('APPLICATION_NAME');

    if (this.oApplication.value === 'cms') {
        document.addEventListener('click', firstClickListener);
    }
};

/*----------------------------------------------------------------------*/
/* PROTOTYPE : EventListeners                                            */
/*----------------------------------------------------------------------*/
DocumentReady.prototype.EventListeners = function () {
    const _ = this;
    /* click Event
    ----------------------------------------------------------------------*/
    document.addEventListener('click', function (event) {
        let cButtonId = event.target.id;
        switch (cButtonId) {
            case 'container--top-of-page-arrow-icon':
                _.ScrollToTopOfPage();
                break;
        }
    });

    /* focusin Event
    ----------------------------------------------------------------------*/
    document.addEventListener('focusin', function (event) {
        if (event.target.type === 'textarea') {
            event.target.style.minHeight = '150px';
        }
    });

    /* keydown Event
    ----------------------------------------------------------------------*/
    document.addEventListener('keydown', (event) => {
        if (event.isComposing) {
            // if (event.isComposing || event.keyCode === 229) {
            return;
        } else if (event.key === 'Enter' && event.target.type !== 'textarea') {
            event.stopPropagation();
            event.preventDefault();
            return;
        }
    });
};

/*----------------------------------------------------------------------*/
/* PROTOTYPE : ScrollToTopOfPage                                        */
/*----------------------------------------------------------------------*/
DocumentReady.prototype.ScrollToTopOfPage = function () {
    window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
    });
};

/*----------------------------------------------------------------------*/
/* rawurldecode (FUNCTION)                                              */
/*----------------------------------------------------------------------*/
// function rawurldecode( str ) {
// Decodes URL-encodes string
//
// version: 901.1411
// discuss at: http://phpjs.org/functions/rawurldecode
// +   original by: Brett Zamir
// *     example 1: rawurldecode('Kevin+van+Zonneveld%21');
// *     returns 1: 'Kevin+van+Zonneveld!'
// *     example 2: rawurldecode('http%3A%2F%2Fkevin.vanzonneveld.net%2F');
// *     returns 2: 'http://kevin.vanzonneveld.net/'
// *     example 3: rawurldecode('http%3A%2F%2Fwww.google.nl%2Fsearch%3Fq%3Dphp.js%26ie%3Dutf-8%26oe%3Dutf-8%26aq%3Dt%26rls%3Dcom.ubuntu%3Aen-US%3Aunofficial%26client%3Dfirefox-a');
// *     returns 3: 'http://www.google.nl/search?q=php.js&ie=utf-8&oe=utf-8&aq=t&rls=com.ubuntu:en-US:unofficial&client=firefox-a'
// var histogram = {};
// var ret = str.toString();

// var replacer = function(search, replace, str) {
//     var tmp_arr = [];
//     tmp_arr = str.split(search);
//     return tmp_arr.join(replace);
// };

// var replace, search;

// The histogram is identical to the one in urlencode.
//     histogram["'"]   = '%27';
//     histogram['(']   = '%28';
//     histogram[')']   = '%29';
//     histogram['*']   = '%2A';
//     histogram['~']   = '%7E';
//     histogram['!']   = '%21';

//     for (replace in histogram) {
//         search = histogram[replace]; // Switch order when decoding
//         ret = replacer(search, replace, ret); // Custom replace. No regexing
//     }

//     // End with decodeURIComponent, which most resembles PHP's encoding functions
//     ret = decodeURIComponent(ret);

//     return ret;
// }

let rawurldecode = (str) => {
    // let rawurldecode = function(str) {
    //       discuss at: https://locutus.io/php/rawurldecode/
    //      original by: Brett Zamir (https://brett-zamir.me)
    //         input by: travc
    //         input by: Brett Zamir (https://brett-zamir.me)
    //         input by: Ratheous
    //         input by: lovio
    //      bugfixed by: Kevin van Zonneveld (https://kvz.io)
    // reimplemented by: Brett Zamir (https://brett-zamir.me)
    //      improved by: Brett Zamir (https://brett-zamir.me)
    //           note 1: Please be aware that this function expects to decode
    //           note 1: from UTF-8 encoded strings, as found on
    //           note 1: pages served as UTF-8
    //        example 1: rawurldecode('Kevin+van+Zonneveld%21')
    //        returns 1: 'Kevin+van+Zonneveld!'
    //        example 2: rawurldecode('https%3A%2F%2Fkvz.io%2F')
    //        returns 2: 'https://kvz.io/'
    //        example 3: rawurldecode('https%3A%2F%2Fwww.google.nl%2Fsearch%3Fq%3DLocutus%26ie%3D')
    //        returns 3: 'https://www.google.nl/search?q=Locutus&ie='

    return decodeURIComponent(
        (str + '').replace(/%(?![\da-f]{2})/gi, function () {
            console.log('rawurldecode HERE I AM IIFFEWWE');
            // PHP tolerates poorly formed escape sequences
            return '%25';
        })
    );
};

export { __USE_JAVASCRIPT_CONSOLE_LOG, DocumentReady, rawurldecode, firstEventPromise };
